import Glide from '@glidejs/glide';

class GlideCarousel extends HTMLElement {
  connectedCallback() {
    this.initializeCarousel();
  }

  initializeCarousel() {
    for (const item of this.carouselElements) {
      new Glide(item, this.options).mount();
    }
  }
}

export default GlideCarousel;
